"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormControl = exports._FormControl = exports.useFormControl = exports.FormControlContext = void 0;

var react_1 = __importStar(require("react"));

var react_hook_form_1 = require("react-hook-form");

var label_1 = require("@react-aria/label");

var components_utils_1 = require("@conte-ltd/components-utils");

exports.FormControlContext = (0, react_1.createContext)(null);

function useFormControl() {
  var _a;

  return (_a = (0, react_1.useContext)(exports.FormControlContext)) !== null && _a !== void 0 ? _a : {};
}

exports.useFormControl = useFormControl;

function _FormControl(props, fwRef) {
  var children = props.children,
      _a = props.isRequired,
      isRequired = _a === void 0 ? false : _a,
      _b = props.isReadOnly,
      isReadOnly = _b === void 0 ? false : _b,
      _c = props.isDisabled,
      isDisabled = _c === void 0 ? false : _c;
  var formState = (0, react_hook_form_1.useFormContext)().formState;

  var _d = (0, label_1.useLabel)(__assign({
    label: 'dummy'
  }, props)),
      labelProps = _d.labelProps,
      fieldProps = _d.fieldProps;

  var _e = __read((0, react_1.useState)({}), 2),
      fieldsState = _e[0],
      setFieldsState = _e[1];

  var context = {
    labelProps: labelProps,
    fieldProps: fieldProps,
    isRequired: isRequired,
    isReadOnly: isReadOnly,
    isDisabled: isDisabled,
    formState: formState,
    fieldsState: fieldsState,
    setFieldsState: setFieldsState
  };
  return react_1.default.createElement("div", __assign({
    ref: fwRef
  }, (0, components_utils_1.styleProps)(props)), react_1.default.createElement(exports.FormControlContext.Provider, {
    value: context
  }, (0, components_utils_1.useRunIfFunction)(children, context, false)));
}

exports._FormControl = _FormControl;
exports.FormControl = (0, react_1.forwardRef)(_FormControl);